import React from "react";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import localeText from "../../../../../../locale";
import { formatPrice } from "../../../../../../utilities/formatPrice";
import ExtrapayDetailRows from "./ExtrapayDetailRows";
import ExtrapayDialogHeading from "./ExtrapayDialogHeading";
import ExtrapayInfoNote from "./ExtrapayInfoNote";

export const WithdrawConfirmDialog = ({
  visible,
  onHide,
  address,
  amount,
  balanceAfter,
  checked,
  onCheck,
  onConfirm,
  submitting,
}) => (
  <Dialog
    visible={visible}
    onHide={onHide}
    draggable={false}
    className="extrapay-flow-dialog"
    style={{ width: "min(680px, 96vw)" }}
    header={
      <ExtrapayDialogHeading
        title={localeText("extrapayFlowConfirmTitle")}
        subtitle={localeText("extrapayFlowConfirmSubtitle")}
      />
    }
  >
    <ExtrapayDetailRows
      rows={[
        {
          label: localeText("extrapayFlowYouReceive"),
          value: localeText("extrapayFlowExcAmount", { amount: formatPrice(amount) }),
        },
        { label: localeText("extrapayFlowNetwork"), value: localeText("extrapayFlowNetworkName") },
        { label: localeText("extrapayFlowDestination"), value: address },
        {
          label: localeText("extrapayFlowPlatformDebit"),
          value: localeText("extrapayFlowExcAmount", { amount: formatPrice(amount) }),
        },
        {
          label: localeText("extrapayFlowBalanceAfter"),
          value: localeText("extrapayFlowExcAmount", { amount: formatPrice(balanceAfter) }),
        },
      ]}
    />
    <div className="flex align-items-start gap-2 mt-4">
      <Checkbox inputId="extrapay-confirm" checked={checked} onChange={(event) => onCheck(event.checked)} />
      <label htmlFor="extrapay-confirm" className="text-sm">
        {localeText("extrapayFlowConfirmCheck")}
      </label>
    </div>
    <div className="mt-3">
      <ExtrapayInfoNote text={localeText("extrapayFlowConfirmNote")} />
    </div>
    <div className="flex align-items-center gap-3 mt-4 flex-wrap">
      <Button
        label={localeText("extrapayFlowConfirmAction")}
        icon="pi pi-arrow-right"
        iconPos="right"
        className="border-round-md border-none"
        style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#fff" }}
        disabled={!checked || submitting}
        loading={submitting}
        onClick={onConfirm}
      />
      <button type="button" className="p-0 border-none bg-transparent cursor-pointer" style={{ color: "#335CFF" }} onClick={onHide}>
        {localeText("extrapayFlowEditValues")}
      </button>
    </div>
  </Dialog>
);

export const WithdrawSuccessDialog = ({ visible, onHide, withdrawal, balance, onTrack, onList }) => (
  <Dialog
    visible={visible}
    onHide={onHide}
    draggable={false}
    closable={false}
    className="extrapay-flow-dialog"
    style={{ width: "min(680px, 96vw)" }}
    header={
      <ExtrapayDialogHeading
        title={localeText("extrapayFlowSuccessTitle")}
        subtitle={localeText("extrapayFlowSuccessSubtitle")}
      />
    }
  >
    <ExtrapayDetailRows
      rows={[
        { label: localeText("extrapayFlowRequest"), value: withdrawal?.id },
        {
          label: localeText("extrapayFlowYouReceive"),
          value: localeText("extrapayFlowExcAmount", { amount: formatPrice(Number(withdrawal?.amount) || 0) }),
        },
        { label: localeText("extrapayFlowAddress"), value: withdrawal?.addressEXC },
        {
          label: localeText("extrapayFlowAvailableBalanceLabel"),
          value: localeText("extrapayFlowExcAmount", { amount: formatPrice(balance) }),
        },
      ]}
    />
    <div className="mt-3">
      <ExtrapayInfoNote text={localeText("extrapayFlowSuccessNote")} />
    </div>
    <div className="flex align-items-center gap-3 mt-4 flex-wrap">
      <Button
        label={localeText("extrapayFlowTrackWithdraw")}
        icon="pi pi-arrow-right"
        iconPos="right"
        className="border-round-md border-none"
        style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#fff" }}
        onClick={onTrack}
      />
      <button type="button" className="p-0 border-none bg-transparent cursor-pointer" style={{ color: "#335CFF" }} onClick={onList}>
        {localeText("extrapayFlowMyWithdrawals")}
      </button>
    </div>
  </Dialog>
);
